import { ArrowBack, Send, Settings } from "@mui/icons-material";
import { IconButton, Paper, Stack, useTheme } from "@mui/material";
import React, { useCallback } from "react";
import Text from "../Text";
import { COLORS } from "../../utilities/theme";
import { TextSize } from "../utils/TextSize";
import { useNavigate } from "react-router-dom";
import { useMeetingStore } from "../../stores/useMeetingStore";
import SquareIconButton from "../SquareIconButton";
import { useTaskFormStore } from "../../stores/useTaskFormStore";
import { useActiveTopicStore } from "../../stores/useActiveTopicStore";
import useLeaveMeetingPage from "../../hooks/utils/useLeaveMeetingPage";
import useEndMeeting from "../../hooks/api/useEndMeeting";

type HostPageHeaderProps = {
    title?: string;
    onSettingClick: () => void;
    onSendClick: () => void;
};

const HostPageHeader = ({
    title,
    onSettingClick,
    onSendClick,
}: HostPageHeaderProps) => {
    const meeting = useMeetingStore((state) => state.meeting);
    const theme = useTheme();

    const leavePage = useLeaveMeetingPage();
    const { endMeeting } = useEndMeeting();

    // host 退出会议：先结束会议（广播 MeetingEnded 踢出所有参会者），再离开当前页面
    const onArrowBack = async () => {
        await endMeeting();
        leavePage();
    };

    return (
        <Stack width={"100%"}>
            <Paper elevation={2}>
                <Stack
                    bgcolor={theme.palette.background.default}
                    padding={2}
                    direction={"row"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                >
                    <Stack
                        spacing={2}
                        direction={"row"}
                        flexDirection={"row"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                    >
                        <IconButton onClick={onArrowBack}>
                            <ArrowBack />
                        </IconButton>
                        <IconButton
                            sx={{
                                borderRadius: 1,
                                opacity: 0,
                                bgcolor: COLORS.grey,
                                cursor: "default",
                            }}
                        >
                            <Send />
                        </IconButton>
                    </Stack>

                    <Stack alignItems={"center"} justifyContent={"center"}>
                        <Text bold>Voting On: {title}</Text>
                        <Text size={TextSize.Small}>{meeting?.topic}</Text>
                    </Stack>

                    <Stack
                        spacing={2}
                        direction={"row"}
                        flexDirection={"row"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                    >
                        <SquareIconButton onClick={onSettingClick}>
                            <Settings />
                        </SquareIconButton>
                        <SquareIconButton onClick={onSendClick}>
                            <Send />
                        </SquareIconButton>
                    </Stack>
                </Stack>
            </Paper>
        </Stack>
    );
};

export default HostPageHeader;
